package ch.wsl.box.model.shared

case class CurrentUser(username:String,roles:Seq[String])
